module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-9 col-xs-12\"> <div id=\"payment_log_daterange_pickers\" class=\"filter-selector\"></div> <div id=\"source_type_selector\" class=\"filter-selector\"></div> <div id=\"request_payment_log_report\" class=\"filter-selector hidden-xs hidden-sm\"></div> </div> </div> <div id=\"payment_log_list\"></div> <div id=\"payment_log_pagination\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/payment_logs/template.ejs
// module id = 809
// module chunks = 1